import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const ReorderIcon24 = (props: SvgProps) => <Svg
  width={24}
  height={24}
  viewBox="0 0 24 24"
  fill="none"
  {...props}
>
  <Path
    d="M5 9L2 12M2 12L5 15M2 12H22M9 5L12 2M12 2L15 5M12 2V22M15 19L12 22M12 22L9 19M19 9L22 12M22 12L19 15"
    stroke="#3379BD"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</Svg>;

export default ReorderIcon24;
